import { Component, OnInit } from '@angular/core';
import { ApidataService } from 'src/app/apidata.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  apiresponse: any;
  loading: boolean = true;
  courses: any[];
  errorMessage: any;
  constructor(private service: ApidataService) { }

  ngOnInit(): void {
    this.getallnavbar();
  }
  getallnavbar(): void {
    this.service.navbargetall().subscribe(
      (res) => {
        this.apiresponse = res;
        this.loading = false;
        if (this.apiresponse.status == true) {
          this.courses = this.apiresponse.data;
          // console.log(this.courses)
          // this.ContactlistLoader = false;

        } else {
          this.loading = false;
          // this.ContactlistLoader = false;
        }
      },
      (error: any) => {
        this.errorMessage = error as any;
        this.loading = false;
        // this.ContactlistLoader = false;
      }

    );
  }
}
